import * as Yup from "yup";
import {FIELD_NUMBER, FIELD_REQUIRED, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as consultationTransactionsFormNames from "./consultationTransactionsFormNames";

export const consultationTransactionsValidationSchema = Yup.object().shape({
  [consultationTransactionsFormNames.ROLE_OPERATEUR_FORM_NAME]:
    Yup.number().typeError(FIELD_NUMBER),
  [consultationTransactionsFormNames.OPERATEUR_FORM_NAME]:
    Yup.number().typeError(FIELD_NUMBER),
  [consultationTransactionsFormNames.UTILISATEUR_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationTransactionsFormNames.ID_TRANSACTION_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationTransactionsFormNames.CRITERE_FACTURATION_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationTransactionsFormNames.REFERENCE_DECLENCHEUR_FORM_NAME]:
    Yup.number().typeError(FIELD_NUMBER),
  [consultationTransactionsFormNames.STATUT_TRANSACTION_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationTransactionsFormNames.CODE_PACKAGE_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationTransactionsFormNames.NUMERO_SOUSCRIPTION_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationTransactionsFormNames.MOTIF_ANNULATION_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationTransactionsFormNames.DATE_DE_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  [consultationTransactionsFormNames.DATE_A_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
});

export const annulationTransactionValidationSchema = Yup.object().shape({
  [consultationTransactionsFormNames.ANNULATION_MOTIF_ANNULATION_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING).required(FIELD_REQUIRED),
});
